export const techAndMeasureTagTooltips = {
  investementExpenditure: [
    {
      value: null,
      text: 'No investment expenditure is needed'
    },
    {
      value: '$',
      text: 'Suggested measure or technology implies a cost of less than 10,000 USD'
    },
    {
      value: '$$',
      text: 'Suggested measure or technology implies a cost higher than 10,000 USD but lower than 150,000 USD'
    },
    {
      value: '$$$',
      text: 'Suggested measure or technology implies a cost higher than 150,000 USD but lower than 500,000 USD'
    },
    {
      value: '$$$$',
      text: 'Suggested measure or technology implies a cost higher than 500,000 USD'
    }
  ],
  impactEnergy: [
    {
      value: 'low',
      text: 'Saving is equal or lower than 15%'
    },
    {
      value: 'medium',
      text: 'Saving is between 16 - 30%'
    },
    {
      value: 'high',
      text: 'Saving is between 31 - 60%'
    },
    {
      value: 'very high',
      text: 'Saving is higher than 60%'
    }
  ],
  impactWater: [
    {
      value: 'low',
      text: 'Saving is equal or lower than 15%'
    },
    {
      value: 'medium',
      text: 'Saving is between 16 - 30%'
    },
    {
      value: 'high',
      text: 'Saving is between 31 - 60%'
    },
    {
      value: 'very high',
      text: 'Saving is higher than 60%'
    }
  ]
};
